(function () {
	'use strict';

	a3_cabin_reports.factory('UserFactory', UserFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name UserFactory
    * @description 
    *   Add, Update, Delete and Get User.
    * @ngInject
    */
	//function UserFactory(localStorageMD5Service, CabinAPIService, DataCleanerFactory, GenericService, LogService, $http, apiUrl) {
	function UserFactory(LogService, localStorageMD5Service, $http, apiUrl, CabinAPIService, DataCleanerFactory, GenericService,azureADAuth) {
       
		var msalConfig = {
            auth: azureADAuth,
            cache: {
                cacheLocation: "sessionStorage", // This configures where your cache will be stored
                storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
				
            }
        };
        var myMSALObj = new msal.PublicClientApplication(msalConfig);
        var username = null;


         myMSALObj.handleRedirectPromise()
         .then(handleResponse)
         .catch((error) => {
             console.error(error);
		 	LogService.error(error, 'Failed to handle redirect Login');
         });

        function handleResponse(response) {
			
            if (response !== null) {
                username = response.account.username;
            } else {
                selectAccount();

            }
        }

        function selectAccount () {
            /**
             * See here for more info on account retrieval: 
             * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
             */
            const currentAccounts = myMSALObj.getAllAccounts();
        
            if (currentAccounts.length === 0) {
                return;
            } else if (currentAccounts.length > 0) {
                username = currentAccounts[0].username;
            }
        }
        
		/**
        * Initialize the User
        * @memberof UserFactory
        */
		function User() {
			this.id = null;
			this.aimsId = null;
			this.name = null;
			this.shortname = null;
			this.position = null;
			this.hashedPwd = null;
			this.token = null;
			this.syncDialogLastDt = null;
			this.getDescription = getDescription;
			this.tokenExtended = false;
			this.hireDate = null;
		}

		var service =
		{
			getUser: getUser,
			setUser: setUser,
			isSecure: isSecure,
			isLoggedIn: isLoggedIn,
			clearActiveUser: clearActiveUser,
			setActiveUser: setActiveUser,
			login: login,
			extendToken: extendToken,
            azlogin: azlogin,
            azSignOut:azSignOut,
			getLoginFailedAttemps: getLoginFailedAttemps,
			newLoginFailedAttemp: newLoginFailedAttemp
		};

		var objType = 'user';
		var objCallback = User;

		//Object Functions
		function getDescription() {
			if (this.aimsid == null && this.name == null) return '-null-';
			else return (this.aimsid || '?') + ' - ' + (this.name || '?');
		}

		//Factory Functions
        /**
         * Get User 
         * @memberof UserFactory
         * @returns {Object} User
         */
		function getUser() {
			return GenericService.getOne(objType, objCallback);
		}

		/**
		* Save User 
		* @memberof UserFactory
		* @param {Object} User
		*/
		function setUser(user) {
			GenericService.saveAll(user, objType, objCallback);
		}

        /**
         * Checks if local storage is on secure mode 
         * @memberof UserFactory
         * @param {boolean} isSecure
         */
		function isSecure() {
			return localStorageMD5Service.isSecure();
		}

		/**
		* Check if user exists and he has logged in
		* @memberof UserFactory
		* @param {boolean} isLoggedIn
		*/
		function isLoggedIn() {
			var user = null;
			try {
				user = getUser();
				if (user != null) {
					var act = localStorageMD5Service.get('active');
					if (!act || !act.aimsId || act.aimsId != user.aimsId) {
						user = null;
					}
				} else
					user = null;
			} catch (e) {
				user = null;
			}
			return user;
		}

        /**
         * Clear Active User
         * @memberof UserFactory
         */
		function clearActiveUser() {
			localStorageMD5Service.remove('active');
		}

        /**
         * Save Active User 
         * @memberof UserFactory
         * @param {Object} User
         */
		function setActiveUser(user) {
			if (user != null && user.aimsId != null) {
				var value = {
					aimsId: user.aimsId
				};
				localStorageMD5Service.set('active', value);
			}
		}

		function azlogin(onsuccess, onerror, onfinally) {
			return new Promise((resolve, reject) => {
				var loginRequest = {
					scopes: ["User.Read"]
				};
				var silentRequest = {
					scopes: ["openid", "profile", "User.Read"],
					redirectUri: "http://localhost:3000/blank.html"
				};
		
				if (username == null) {
					myMSALObj.loginRedirect(loginRequest);
					resolve(); // Resolve immediately for redirect scenario
				} else {
					silentRequest.account = myMSALObj.getAccountByUsername(username);
					var token = null;
		
					myMSALObj.acquireTokenSilent(silentRequest)
						.then(tokenResponse => {
							if (!tokenResponse.idToken) {
								LogService.error('response.idToken is undefined');
								newLoginFailedAttemp(); // Run newLoginFailedAttemp() if idToken is undefined
								reject(new Error('Token is not available')); // Reject the promise
							} else {
								token = tokenResponse.idToken;
								localStorageMD5Service.remove('failedLoginAttemps');
								login(token, onsuccess, onerror, onfinally);
								resolve(); // Resolve after successful login
							}
						})
						.catch(error => {
							if (error instanceof msal.InteractionRequiredAuthError) {
								LogService.error(error, 'Fallback to interaction when silent call fails');
								 // Handle the redirection process error here if needed
								 myMSALObj.acquireTokenRedirect(silentRequest)
								 .then(() => {
									 // Continue with the process after successful redirection
									 resolve();
								 })
								 .catch(redirectError => {
									 LogService.error(redirectError, 'Error during redirection');
									 newLoginFailedAttemp(); // Run newLoginFailedAttemp() for redirection errors
									 reject(redirectError); // Reject the promise with the redirection error
								 });
							} else {
								LogService.error(error, 'Failed to acquire token silently');
								newLoginFailedAttemp(); // Run newLoginFailedAttemp() for other errors
								reject(error); // Reject the promise with the error
							}
						})
				}
			});
		}


        function azSignOut() {

            /**
             * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
             * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
             */
        
            const logoutRequest = {
                account: myMSALObj.getAccountByUsername(username),
                postLogoutRedirectUri: window.location.href

            };
        
            myMSALObj.logoutRedirect(logoutRequest);
        }

        /**
         * Add code to try to login locally if remote login fails with a 404 or timeout
         * @memberof UserFactory
         * @param {string} token
         * @param {function} onsuccess callback function if the call is a success
         * @param {function} onerror callback function if the call failed
         * @param {function} onfinally callback function that runs on the end
         */
		function login(token,onsuccess, onerror, onfinally) {
			clearActiveUser();
			var q = CabinAPIService.login(token);
			q.then(function (response) {

				// if the user that tries to log in is different than the last
				// logged in user, then reset all stored server data
				if (getUser() != null) {
					if (getUser().aimsId.toString() != response.data.data.aimsId.toString()) {
						DataCleanerFactory.deleteAllData();
					}
				}

				// delete any flights created locally, that do not have any local
				// reports
				DataCleanerFactory.deleteOrphanedLocalFlights();

				// assign the logged in user
				var user = response.data.data;

				setUser(user);
				setActiveUser(user);
				if (typeof (onsuccess) == "function") {
					onsuccess();
				}
			});

			q.catch(function (response) {
				if (typeof (onerror) == "function") {
					onerror(response);
				}
			});

			q.finally(function (response) {
				if (typeof (onfinally) == "function") {
					onfinally();
				}
			});
			return q;
		}

		/**
		* the function that extends the token for limited time if a user forgot their password
		* @memberof UserFactory
		* @param {function} onsuccess callback function if the call is a success
		* @param {function} onerror callback function if the call failed
		*/
		function extendToken(onsuccess, onerror) {
			var user = getUser();
			$http.post(apiUrl + '/login/extendtoken', { 'Token': user.token }, { 'Content-Type': 'application/json' })
				.then(function (response) {
					user.token = response.data.data;
					user.tokenExtended = true;
					setUser(user);
					setActiveUser(user);
					if (typeof (onsuccess) == "function") {
						onsuccess();
					}
				}).catch(function (response) {
					if (typeof (onerror) == "function") {
						onerror(response);
					}
				});

		}

		function getLoginFailedAttemps (){
			var failedLoginAttemps = localStorageMD5Service.get('failedLoginAttemps');
			if(failedLoginAttemps){
				return failedLoginAttemps;
			}
			else{
				return 0;
			}
		}
		function newLoginFailedAttemp (){
			var value = 1;
			var failedLoginAttemps = localStorageMD5Service.get('failedLoginAttemps');
			if(failedLoginAttemps && failedLoginAttemps !== "null"){
				var attempsToNumber = Number(failedLoginAttemps);
				value = value + attempsToNumber;
			}
			localStorageMD5Service.set('failedLoginAttemps', value);
		}
		return service;
	}

})();
